exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-root {\n  height: 55px;\n  width: 100%;\n  display: flex;\n  align-items: center; }\n\n.logo-container {\n  width: 240px;\n  display: flex;\n  align-items: center;\n  justify-content: space-evenly; }\n  .logo-container img {\n    height: 40px;\n    cursor: pointer; }\n\n.header-text {\n  flex-grow: 1;\n  text-align: center; }\n  .header-text p {\n    font-size: 24px;\n    font-weight: 500;\n    margin: 0; }\n\n.icon-toggle {\n  width: 23px !important;\n  height: 40px;\n  margin-left: 3rem;\n  color: #28363D;\n  cursor: pointer; }\n", ""]);

// exports
